module.exports = __webpack_public_path__ + "img/4-1.390e4537.svg";